
export const AuditTypesValue = {
  src: 9,
  appName: 10,
  androidDetail: 11,
  advancedCreative: 12,
  btnText: 14,
  subTitle: 15,
  advancedCreativeType: 16,
  creative: 19,
  image: 20,
  video: 21,
  title: 22,
  textSummary: 23,
  labelSummary: 24,
  productImage: 25,
  productSellingPoints: 26,
  productDescribe: 27
}

export const CreativeAuditTypes = [
  AuditTypesValue.src,
  AuditTypesValue.appName,
  AuditTypesValue.androidDetail,
  // AuditTypesValue.advancedCreative,
  AuditTypesValue.btnText,
  AuditTypesValue.subTitle,
  AuditTypesValue.advancedCreativeType,
  AuditTypesValue.creative,
  AuditTypesValue.image,
  AuditTypesValue.video,
  AuditTypesValue.title,
  AuditTypesValue.textSummary,
  AuditTypesValue.labelSummary,
  AuditTypesValue.productImage,
  AuditTypesValue.productSellingPoints,
  AuditTypesValue.productDescribe
]

export const AuditTypes = {
  '1': '计划',
  '2': '落地页',
  '3': '下载链接',
  '4': '文章标题',
  '5': '应用直达链接',
  '6': '应用包名',
  '7': '录入文章内容',
  '8': '文章id',
  '9': '来源',
  '10': '应用名',
  '11': '安卓详情页链接',
  '12': '附加创意',
  '13': '电话拨打',
  '14': '按钮文本',
  [AuditTypesValue.advancedCreativeType]: '附加创意链接',
  '16': '副标题',
  '17': '小程序',
  '18': '文章链接',
  [AuditTypesValue.creative]: '创意',
  [AuditTypesValue.image]: '图片',
  [AuditTypesValue.video]: '视频',
  [AuditTypesValue.title]: '标题',
  '23': '文本摘要',
  '24': '标签摘要',
  '25': '卡片主图',
  '26': '推广卖点',
  '27': '卡片标题'
}

export const ReviewType = {
  ads: {
    value: 1,
    text: '广告审核'
  },
  content: {
    value: 2,
    text: '内容审核'
  }
}
